import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="bg-beige py-20 md:py-28 px-4" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-brown leading-relaxed" data-id="element-70">
          <p data-id="element-71">
            El sistema en EE.UU. está diseñado para que trabajes 60 horas a la
            semana y mueras con tus sueños enterrados. Si eres como la mayoría
            de los latinos de fe, te da miedo la tecnología, te aterra el tema
            legal de las LLC y, honestamente, te sientes culpable por querer
            prosperar económicamente.
          </p>

          <p data-id="element-72">
            Ves a otros "gurús" latinos hablando de lujos y marketing agresivo,
            y sientes que ese no es tu camino. Tú quieres{' '}
            <strong className="text-gold-hover font-serif text-2xl md:text-3xl block my-4" data-id="element-73">
              Prosperidad con Propósito.
            </strong>
          </p>

          <p data-id="element-74">
            Quieres un negocio que te permita ir a la iglesia los miércoles,
            cenar con tus hijos todas las noches y, sobre todo, tener{' '}
            <strong className="text-charcoal" data-id="element-75">
              la paz de que estás operando bajo la cobertura de Dios.
            </strong>
          </p>

          <div className="p-6 md:p-8 border-l-4 border-gold bg-cream/50 mt-8" data-id="element-76">
            <p className="font-medium italic" data-id="element-77">
              La falta de un sistema no es solo una falta de dinero; es una
              falta de libertad para cumplir tu llamado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}